<template>
    <biller-modal :isVisible="showModal">
        <div class="p-8 modal-width text-center">
            <p class="text-base text-grey-300 font-semibold my-5">Paycode Transfer Reference</p>
            <div class="mt-12 mb-10">
                <p class="text-smoke-100 text-sm">Billerpay PayCode</p>
                <p class="font-medium text-grey-300 mt-2 text-double">
                    {{ paycodeResponse.payWithMobileToken }}
                </p>
            </div>
            <div class="bg-snow-300 rounded-lg py-10 px-8 flex items-center justify-between">
                <div class="text-left">
                    <p class="text-smoke-100 text-sm">Amount</p>
                    <p class="text-sm text-grey-300 mt-2 font-medium">
                        ₦{{ Object.values(data).length ? data.amount : 0 | formatAmount }}
                    </p>
                </div>
                <div class="text-left">
                    <p class="text-smoke-100 text-sm">Validity</p>
                    <div class="flex items-center mt-2">
                        <svg
                            width="14"
                            height="14"
                            viewBox="0 0 16 16"
                            class="mr-1"
                            fill="#C0CCDA"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M11.2001 7.2H8.80014V4.8C8.80014 4.3576 8.44174 4 8.00014 4C7.55854 4 7.20014 4.3576 7.20014 4.8V8C7.20014 8.4424 7.55854 8.8 8.00014 8.8H11.2001C11.6425 8.8 12.0001 8.4424 12.0001 8C12.0001 7.5576 11.6425 7.2 11.2001 7.2ZM7.99972 14.4C4.47092 14.4 1.59972 11.5288 1.59972 8C1.59972 4.4712 4.47092 1.6 7.99972 1.6C11.5285 1.6 14.3997 4.4712 14.3997 8C14.3997 11.5288 11.5285 14.4 7.99972 14.4ZM8 0C3.5888 0 0 3.5888 0 8C0 12.4112 3.5888 16 8 16C12.4112 16 16 12.4112 16 8C16 3.5888 12.4112 0 8 0Z"
                            />
                        </svg>
                        <p class="text-sm text-grey-300 tracking-wide font-medium">
                            {{ hours }}:{{ minutes }}:{{ seconds }}
                        </p>
                    </div>
                </div>
            </div>

            <div class="mt-16 mb-5">
                <button
                    @click="$emit('close')"
                    class="font-semibold bg-orange-pale text-base text-orange px-6 py-4 rounded-lg"
                >
                    Close
                </button>
            </div>
        </div>
    </biller-modal>
</template>

<script>
import { formatAmount } from '@/util/formatAmount'
import countdown from '@/util/countdown'
export default {
    data() {
        return {
            minutes: 0,
            seconds: 0,
            hours: 0,
        }
    },
    filters: {
        formatAmount: function(val) {
            return formatAmount(val)
        },
    },
    props: {
        showModal: {
            type: Boolean,
            default: false,
        },

        data: {
            type: Object,
        },
    },

    computed: {
        paycodeResponse: function() {
            if (Object.values(this.data).length && this.data.paycode_response) {
                return this.data.paycode_response
            } else {
                return {
                    payWithMobileToken: '000000000',
                    tokenLifeTimeInMinutes: 0,
                }
            }
        },
    },

    watch: {
        data: {
            handler() {
                this.getExpiryTime()
            },
            deep: true,
        },
    },

    methods: {
        getExpiryTime() {
            let startTime = new Date()

            startTime.setMinutes(startTime.getMinutes() + Number(this.paycodeResponse.tokenLifeTimeInMinutes))
            clearInterval(this.interval)

            this.interval = setInterval(() => {
                const remainingTime = countdown(startTime.getTime())

                if (Object.entries(remainingTime).length) {
                    this.minutes = remainingTime.minutes
                    this.seconds = remainingTime.seconds
                    this.hours = remainingTime.hours
                } else {
                    clearInterval(this.interval)
                }
            }, 1000)
        },
    },
}
</script>

<style scoped>
@media screen and (min-width: 640px) {
    .modal-width {
        width: 400px;
    }
}

.modal-width {
    min-width: 320px;
}
</style>
